import { useQuery } from "react-query";
import { rightholderEarningsApi, } from "frontend/src/api/rightholder-earnings";
import { cacheKey } from "./shared";
export var useRightholderEarnings = function (params) {
    return useQuery([cacheKey, params], function () {
        return rightholderEarningsApi.index(params);
    });
};
